import { Button } from "V2.0/common/button";

import { IntegrationShell } from "../common/Shell";
import MakeLogo from "V2.0/images/make.svg";
import { useOutletContext } from "react-router-dom";

function MakeComponent({ isViewOnly }) {
  const openMakeInNewTab = () => {
    window.open(
      "https://www.make.com/en/hq/app-invitation/ea6161d2955f4a180ca1e2d8e3f4b529",
      "_blank",
    );
  };

  return (
    <div>
      <div className="flex flex-col items-center">
        <div className="w-full max-w-md px-4 py-10 sm:px-6 lg:px-8 lg:py-6 border rounded-lg">
          <img
            src={MakeLogo}
            width={100}
          />
          {/* <h3 className="text-base font-semibold leading-6 text-gray-900">
            Make invite
          </h3> */}
          <div className="mt-2 text-sm text-gray-500">
            <p>Automate your workflows using Make</p>
          </div>
          {!isViewOnly && (
            <Button
              className="mt-5"
              onClick={openMakeInNewTab}
            >
              Connect Make
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export function MakeIntegration() {
  const { isViewOnly } = useOutletContext<{ isViewOnly: boolean }>();
  return (
    <IntegrationShell>
      <MakeComponent isViewOnly={isViewOnly} />
    </IntegrationShell>
  );
}
